import React from 'react';
import { Ruler, Compass, Map } from 'lucide-react';
import img1 from "../../assets/archplan.jpg";
import img2 from "../../assets/archplan1.jpg";
import img3 from "../../assets/archplan2.jpg";
import img4 from "../../assets/archplan3.jpg";
import img5 from "../../assets/archplan5.jpg";

   

const plans = [
  { 
    id: 1, 
    title: 'Architectural Blueprints', 
    category: 'Drafting', 
    image: img1
  },
  { 
    id: 2, 
    title: '3D Elevation Models', 
    category: 'Modeling', 
    image: img2 
  },
  { 
    id: 3, 
    title: 'Urban Landscape Planning', 
    category: 'Landscape', 
    image: img3
  },
  { 
    id: 4, 
    title: 'Sustainable Design', 
    category: 'Eco-Friendly', 
    image: img4
  },
];

const ArchitecturePlanning = () => {
  return (
    <div className="font-sans text-gray-800 bg-white">
      {/* Hero */}
      <div
  className="relative h-[60vh] w-full bg-cover bg-center"
  style={{ backgroundImage: `url(${img5})` }}
>

        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
          <h4 className="text-amber-500 font-bold tracking-widest uppercase mb-3">Blueprint for Perfection</h4>
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-4">Architecture Planning</h1>
          <p className="text-gray-200 text-lg max-w-xl">Designing the skyline, one structure at a time.</p>
        </div>
      </div>

      {/* Intro */}
      <section className="py-16 px-6 bg-white text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4">Precision & Perspective</h2>
        <div className="w-20 h-1 bg-amber-500 mx-auto mb-6"></div>
        <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Before the first stone is laid, the vision exists on paper. Our architecture planning services provide detailed 2D layouts, structural analysis, and 3D elevations to ensure your project is feasible, beautiful, and compliant.
        </p>
      </section>

      {/* Gallery */}
      <section className="py-16 bg-gray-50 px-6">
        <div className="max-w-7xl mx-auto">
          <h3 className="text-3xl font-serif font-bold text-gray-900 mb-8 text-center md:text-left">Planning Portfolio</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {plans.map((item) => (
              <div key={item.id} className="group relative overflow-hidden shadow-lg cursor-pointer rounded-sm">
                <div className="h-80 overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transform group-hover:scale-110 transition duration-700"/>
                </div>
                <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/90 to-transparent p-6 pt-20">
                  <p className="text-amber-400 text-xs tracking-widest uppercase mb-1">{item.category}</p>
                  <h4 className="text-2xl font-serif text-white">{item.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 px-6 bg-stone-900 text-white">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="flex flex-col items-center">
            <Ruler className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Space Optimization</h4>
            <p className="text-gray-400 text-sm">Efficient layouts that maximize utility and flow.</p>
          </div>
          <div className="flex flex-col items-center">
            <Compass className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">3D Modeling</h4>
            <p className="text-gray-400 text-sm">Visualize your project with photorealistic renders.</p>
          </div>
          <div className="flex flex-col items-center">
            <Map className="w-10 h-10 text-amber-500 mb-4" />
            <h4 className="text-xl font-serif font-bold mb-2">Regulatory Approval</h4>
            <p className="text-gray-400 text-sm">We handle blueprints compliant with local building codes.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-6 text-center bg-white">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6">Let's Map Your Vision</h2>
        <button className="bg-amber-500 hover:bg-amber-600 text-white text-lg font-semibold px-8 py-3 rounded-sm transition shadow-lg">Start Planning</button>
      </section>
    </div>
  );
};

export default ArchitecturePlanning;